import { gql } from '@apollo/client';

export const GET_PORTFOLIO = gql`
  query GetPortfolio($id: ID!) {
    portfolio: getPortfolio(id: $id) {
      id
      name
      isArchived
      creator {
        id
        firstName
        lastName
        email
      }
      assignedTo {
        id
        firstName
        lastName
        email
      }
      owner {
        id
        funder {
          id
          name
        }
        serviceProvider {
          id
          name
        }
        institution {
          id
          name
        }
      }
      programmes {
        id
        name
      }
    }
  }
`;
